import type { BaseBlog } from '@bulknutrients/bulk-shared-lib/interfaces/Blog';
import { BlogCard } from '@components/Blog/BlogCard';

export function BlogList({ data }: { data: BaseBlog[] }) {
  return (
    <div>
      <div className="ga-search-list ga-search-blogs grid grid-cols-1 gap-10 pb-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {data.map((d) => (
          <BlogCard
            key={d.slug}
            blog={d}
            className="!max-w-[400px]" // make blog cards same width as ambassadors/experts
            data-umami-event-location="Search Results Blog List Card"
          />
        ))}
      </div>
    </div>
  );
}
